<template>
  <div class="result-container">
    <HeaderReadingListeningResult
        :question-and-answer-info="questionAndAnswerInfo"
        @changeSkill="handleChangeSkill"
    />
    <hr class="divider" />
    <div class="content-wrapper">
      <div class="questions-list">
        <QuestionAndAnswer
            v-for="(item, index) in questionAnswers && questionAnswers?.groupQuestions"
            :key="`${index + 1}-question-answer`"
            :answers="questionAndAnswerInfo && questionAndAnswerInfo?.user_answers"
            :questions="item"
        />
      </div>
      <div class="pagination">
        <el-button class="btn-gray" @click="handleBack" :disabled="currentPage === 0">
          <i class="el-icon-arrow-left"></i>
        </el-button>
        <el-button
            v-for="(item, index) in displayedPages"
            :key="index"
            @click="handleChangePage(item)"
            :disabled="item === '...'"
            :class="[
            item === currentPage ? 'btn-active' : 'btn-gray',
            item === '...' ? 'btn-disabled' : ''
          ]"
        >
          {{ item === '...' ? '...' : item + 1 }}
        </el-button>

        <el-button class="btn-gray" @click="handleNext" :disabled="currentPage === totalPages - 1">
          <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

import QuestionAndAnswer from "@/view/pages/classes/components/QuestionAndAnswer.vue";
import HeaderReadingListeningResult from "@/view/pages/classes/components/HeaderReadingListeningResult.vue";

export default {
  name: 'ReadingListeningResult',
  components: {
    QuestionAndAnswer,
    HeaderReadingListeningResult,
  },
  props: {
    questionAndAnswerInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentPage: 0,
      maxVisiblePages: 1
    }
  },
  computed: {
    totalPages() {
      return (
          (this.questionAndAnswerInfo &&
              this.questionAndAnswerInfo.questions &&
              this.questionAndAnswerInfo.questions.sections &&
              this.questionAndAnswerInfo.questions.sections.length) ||
          0
      )
    },
    displayedPages() {
      const pages = []
      const total = this.totalPages
      const current = this.currentPage
      const maxPages = this.maxVisiblePages

      if (total <= maxPages) {
        for (let i = 0; i < total; i++) pages.push(i)
        return pages
      }

      if (maxPages === 1) {
        pages.push(current)
        if (current < total - 1) {
          pages.push('...')
          pages.push(total - 1)
        }
        return pages
      }

      const half = Math.floor(maxPages / 2)
      let start = Math.max(0, current - half)
      let end = start + maxPages - 1

      if (end >= total) {
        end = total - 1
        start = Math.max(0, end - maxPages + 1)
      }

      if (start > 0) {
        pages.push(0)
        if (start > 1) pages.push('...')
      }

      for (let i = start; i <= end; i++) {
        if ((i === 0 && start > 0) || (i === total - 1 && end < total - 1)) {
          continue
        }
        pages.push(i)
      }

      if (end < total - 2) {
        pages.push('...')
      }

      if (end < total - 1) {
        pages.push(total - 1)
      }

      return pages
    },
    questionAnswers() {
      if (this.questionAndAnswerInfo?.questions?.sections) {
        return this.questionAndAnswerInfo.questions.sections[this.currentPage]
      }
    }
  },
  methods: {
    updateMaxVisiblePages() {
      const width = window.innerWidth
      if (width >= 1280) {
        this.maxVisiblePages = 10
      } else if (width >= 768) {
        this.maxVisiblePages = 3
      } else {
        this.maxVisiblePages = 1
      }
    },
    handleChangeSkill(value) {
      this.currentPage = 0
      this.$emit('changeSkill', value)
    },
    handleBack() {
      if (this.currentPage > 0) this.currentPage--
    },
    handleNext() {
      if (this.currentPage < this.totalPages - 1) this.currentPage++
    },
    handleChangePage(page) {
      if (page !== '...') {
        this.currentPage = page
      }
    }
  },
  mounted() {
    this.updateMaxVisiblePages()
    window.addEventListener('resize', this.updateMaxVisiblePages)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMaxVisiblePages)
  }
}
</script>

<style scoped>
.result-container {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
}

.divider {
  margin: 8px 0;
}

.content-wrapper {
  margin: 10px;
}

.questions-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  height: 100%;
}

@media (min-width: 1024px) {
  .questions-list {
    height: calc(100vh - 394px);
  }
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 10px;
}

.btn-gray {
  background-color: #f9fafb;
}

.btn-active {
  background-color: #3b82f6;
  color: white;
}

.btn-disabled {
  cursor: default;
}
</style>
